angular.module('bmsApp.dashboard')
	.factory('PushNotificationSvc', [
		'$rootScope',
		'$modal',
		'notify',
		'CRUDSvc',
		'PUSH_NOTIFICATION_API',
		function ($rootScope,
				  $modal,
				  notify,
				  CRUDSvc,
				  PUSH_NOTIFICATION_API) {

			return {
				showModal: function () {
					var modalInstance = $modal.open({
						animation: true,
						templateUrl: 'ng/push-notification/templates/PushNotificationForm.html',
						controller: 'PushNotificationFormModalCtrl',
						size: 'md',
						scope: $rootScope,
						backdrop: 'static', // disable click-outside closing modal
						resolve: {
						}
					});

					return modalInstance.result;
				},
				send: function (params) {
					return CRUDSvc.post(PUSH_NOTIFICATION_API.SEND, params);
				},
			};

		}
	])
	.constant('PUSH_NOTIFICATION_API', {
		SEND: 'api/push-notification/send',
	});
